import React, { useEffect, FC } from 'react';
import { documentService } from '../../../utils/window.utils';
import './styles.scss';

const SpecCheckPluginContainer: FC<{ embedId: string | undefined }> = ({ embedId }) => {
  useEffect(() => {
    const pluginScriptUrl = 'https://lite.speccheck.com/js/plugin-ko-p.js';
    const pluginScriptElement = documentService()?.createElement('script');
    pluginScriptElement.src = pluginScriptUrl;
    pluginScriptElement.onload = function () {
      const scriptElement = documentService()?.createElement('script');
      scriptElement.setAttribute('type', 'text/javascript');
      scriptElement.innerHTML = `
       var specCheckProperties = {};
        specCheckProperties.promise = Promise;
        specCheckProperties.knockout = ko;
        specCheckProperties.container = document.getElementById("jsEmbed");
        specCheckProperties.embedId = ${embedId};
        new SpecCheckLite(specCheckProperties).create();
    `;
      documentService()?.head.appendChild(scriptElement);
    };
    documentService()?.head.appendChild(pluginScriptElement);
  }, []);

  return (
    <section className="specCheck__container">
      <div id="jsEmbed"></div>
    </section>
  );
};

export default SpecCheckPluginContainer;
